import React, { Fragment, Component, createRef } from 'react';
import cn from 'classnames';
import {
  Button,
  FormGroup,
  Label,
  InputGroup,
  InputGroupAddon,
  Input,
  FormText,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import { injectIntl, FormattedMessage } from 'react-intl';
import { bool, number, string, array, func } from 'prop-types';
import { FMessage, iFMessage } from '../../../hoc/IntlComponents';
import { animatedScrollTo } from '../../../utils/utils';
import {
  SupportTextComponent,
  AfterApprovePhoneTextComponent,
  CodeGenTextLinkComponent,
  InvalidPurseNumberText,
  BlockChangesText,
  // WmzEmptyText,
  DeleteBtn,
  RegesterWithEPayments,
  GetCodeBtn,
} from '../PaymentPursesListItemBlocks';
// import PaymentPursesListItemView from './View';
import { PaymentPursesListItemView } from '../index';
import { STATIC_PATH } from '../../../config';

class PaymentPursesListItem extends Component {
  static propTypes = {
    type: number.isRequired,
    title: string.isRequired,
    multiple: bool.isRequired,
    regexp: array,
    wallets: array,
    placeholder: string,
    onSavePurse: func.isRequired,
  };

  static defaultProps = {
    multiple: false,
    loading: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      number: '',
      // firstName: '',
      // lastName: '',
      error: null,
      isFocused: this.setFocused(),
      newWalletSMSInput: '',
      newWalletSMSInputError: false,
      openWalletMenuId: null,
      editWalletId: null,
      editWalletNumber: '',
      editWalletError: null,
      isEditWalletModalOpen: false,
    };
    this.newPurseRef = createRef();
  }

  componentDidMount() {
    const { type: inputType, clearRedirectToPaymentsData, redirectToPaymentsData } = this.props;
    if (redirectToPaymentsData) {
      const { type } = redirectToPaymentsData;
      if (type && type === inputType) {
        if (this.newPurseRef && this.newPurseRef.current) {
          // без таймаута не работает скролл до нижних инпутов
          setTimeout(() => animatedScrollTo(this.newPurseRef.current, 400, 80), 0);
          clearRedirectToPaymentsData();
        }
      }
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.wallets !== this.props.wallets) {
      this.setState(() => ({ number: '', newWalletSMSInput: '' }));
    }
  }

  getFormClassName = (index) => {
    return '';
    // const { wallets, multiple, maxWalletsForMultiple } = this.props;
    // if (!multiple) {
    //   return '';
    // }
    // if (multiple) {
    //   if (index === wallets.length - 1) {
    //     if (wallets.length === maxWalletsForMultiple) {
    //       return 'no-margin';
    //     } else {
    //       return 'no-margin';
    //     }
    //   }
    // }
    // return 'no-margin';
  };

  setFocused = () => {
    const { type: inputType, redirectToPaymentsData } = this.props;
    if (redirectToPaymentsData) {
      const { type } = redirectToPaymentsData;
      if (type && type === inputType) {
        return true;
      }
    }
    return false;
  };

  handleDelete = (id, type) => {
    this.setState({ openWalletMenuId: null });
    this.props.onDeletePurse(id, type);
  };

  toggleWalletMenu = (id) => {
    this.setState((prevState) => ({
      openWalletMenuId: prevState.openWalletMenuId === id ? null : id,
    }));
  };

  handleEditWallet = (id, number) => {
    this.setState({
      openWalletMenuId: null,
      editWalletId: id,
      editWalletNumber: number,
      editWalletError: null,
      isEditWalletModalOpen: true,
    });
  };

  closeEditWalletModal = () => {
    this.setState({
      editWalletId: null,
      editWalletNumber: '',
      editWalletError: null,
      isEditWalletModalOpen: false,
    });
  };

  handleEditWalletNumberChange = ({ target }) => {
    this.setState({ editWalletNumber: target.value, editWalletError: null });
  };

  handleEditWalletSubmit = () => {
    const { editWalletId, editWalletNumber } = this.state;
    const { intl, type, handleSubmitWithSMS, handleValidate, regexp, submitCatchCB, submitThenCB } =
      this.props;

    if (handleValidate(regexp, editWalletNumber)) {
      this.setState({ editWalletError: <InvalidPurseNumberText intl={intl} /> });
      return;
    }

    handleSubmitWithSMS({
      submitData: {
        wallet_id: editWalletId,
        wallet_num: editWalletNumber,
        wallet_type: type,
        type,
        number: editWalletNumber,
      },
      submitCatchCB: submitCatchCB.bind(this),
      submitThenCB: submitThenCB.bind(this),
    });
    this.closeEditWalletModal();
  };

  // handleEdit = (id, type, firstname, lastname) => {
  //   this.props.onEditCard(id, type, firstname, lastname);
  // };

  handleBlur = () => {
    this.setState(() => ({
      isFocused: false,
    }));
    this.inputBlurHandler();
  };

  handleChange = ({ target }) => {
    this.setState(() => ({
      number: target.value,
      error: false,
    }));
  };

  handleBankCardNumberChange = ({ target }) => {
    this.setState(() => ({
      number: target.value.replace(/ /g, ''),
      error: false,
    }));
  };

  formatBankCardNumber = (number) => {
    const numArr = number.split('');
    for (let i = 1, j = 0; i < number.length; i++) {
      if (i % 4 === 0) {
        numArr.splice(i + j, 0, ' ');
        j++;
      }
    }
    return numArr.join('');
  };

  // handleNameChange = ({ target: { value } }, type) => {
  //   if (!value.match(/[^a-z]/gi)) {
  //     this.setState(() => ({
  //       [`${type}Name`]: value,
  //       error: false,
  //     }));
  //   }
  // };

  handleNewWalletChange = ({ target }) =>
    this.setState(() => ({ newWalletSMSInput: target.value, newWalletSMSInputError: false }));

  handleSubmit = (errorStateField, id) => {
    const { newWalletSMSInput, number, firstName, lastName } = this.state;
    const { intl, type, handleSubmitWithSMS, handleValidate, regexp, submitCatchCB, submitThenCB } =
      this.props;

    const wallet_num = id === null ? number : newWalletSMSInput;
    const hasError = handleValidate(regexp, wallet_num);

    let errorFieldComponent = { [errorStateField]: '' };
    if (hasError) {
      errorFieldComponent[errorStateField] = <InvalidPurseNumberText intl={intl} />;
      this.setState((prevState) => ({
        ...prevState,
        ...errorFieldComponent,
      }));
    }
    const submitData = {
      wallet_id: id,
      wallet_num: wallet_num,
      wallet_type: type,
      type,
      number: wallet_num,
      // firstname: firstName.toUpperCase(),
      // lastname: lastName.toUpperCase(),
    };
    if (!hasError) {
      handleSubmitWithSMS({
        submitData,
        submitCatchCB: submitCatchCB.bind(this),
        submitThenCB: submitThenCB.bind(this),
      });
    }
  };

  renderWalletsLabel = ({ id, index, theme }) => {
    const { type, title, multiple, wallets } = this.props;
    let labelId = `purse-${type}`;
    if (id !== undefined) {
      labelId = labelId + `-${id}`;
    }

    if ((type === 3 && index === 0) || (type === 41 && 0 === index)) {
      return (
        <Fragment>
          <h3 className="wallet-label" for={labelId}>
            {title}
          </h3>
          <FormText color="muted">{this.renderMutedText({ newField: true })}</FormText>
          <div className={cn('form-group-upper-label', 'form-group')}>
            <Label for={labelId}>
              {<FMessage id={`payment-data.wallets.code-gen.new.${type}`} />}
            </Label>
          </div>
        </Fragment>
      );
    }

    if (!multiple || index === 0) {
      if (wallets.length === 0) {
        return (
          <Fragment>
            <h3 className="wallet-label" for={labelId}>
              {/* {theme === 4 && (
                <img
                  className="mr-2"
                  src={`${STATIC_PATH}/img/wallets/${type}.png`}
                  width="25px"
                  height="25px"
                />
              )} */}
              {title}
            </h3>
            <FormText color="muted">{this.renderMutedText({ newField: true })}</FormText>
            <div className={cn('form-group-upper-label', 'form-group')}>
              <Label for={labelId}>
                <FMessage id={`payment-data.wallets.code-gen.new.${type}`} />
              </Label>
            </div>
          </Fragment>
        );
      }
      return (
        <Fragment>
          <h3 className="wallet-label" for={labelId}>
            {title}
          </h3>
          <FormText color="muted">{this.renderMutedText({ newField: true })}</FormText>
          <div className={cn('form-group-upper-label', 'form-group')}>
            <Label for={labelId}>
              {/* {theme === 4 && (
                <img
                  className="mr-2"
                  src={`${STATIC_PATH}/img/wallets/${type}.png`}
                  width="25px"
                  height="25px"
                />
              )} */}
              <FMessage id={`payment-data.wallets.code-gen.new.${type}`} />
            </Label>
          </div>
        </Fragment>
      );
    } else if (multiple && wallets.length === index) {
      return (
        <Label for={labelId}>
          {/* {theme === 4 && (
            <img
              className="mr-2"
              src={`${STATIC_PATH}/img/wallets/${type}.png`}
              width="25px"
              height="25px"
            />
          )} */}

          <FMessage id={`payment-data.wallets.code-gen.new.${type}`} />
        </Label>
      );
    } else {
      return null;
    }
  };

  // renderNewBankCardRU = index => {
  //   const { type, placeholder, isSlave, theme, wallets } = this.props;
  //   const { number, error, isFocused, firstName, lastName } = this.state;
  //   const disabled = isSlave;
  //   return (
  //     <FormGroup className={error ? 'has-error' : ''}>
  //       {index === 0 ? this.renderWalletsLabel({ index, theme }) : null}
  //       <div className="bank-card-wrapper">
  //         <div>
  //           <Label>
  //             <FMessage id="payments.purses.card.number" />
  //           </Label>
  //           <Input
  //             innerRef={this.newPurseRef}
  //             id={`purse-${type}`}
  //             className="text-uppercase"
  //             placeholder={placeholder}
  //             value={this.formatBankCardNumber(number)}
  //             onChange={this.handleBankCardNumberChange}
  //             disabled={disabled}
  //             onBlur={this.handleBlur}
  //             onFocus={this.inputFocusHandler}
  //             autoFocus={isFocused}
  //           />
  //         </div>
  //         <div>
  //           <label>
  //             <FMessage id="payments.purses.card.first-name" />
  //           </label>
  //           <Input
  //             className="text-uppercase"
  //             placeholder="IVAN"
  //             value={firstName}
  //             onChange={(e) => this.handleNameChange(e, 'first')}
  //             disabled={disabled}
  //             onBlur={this.handleBlur}
  //             onFocus={this.inputFocusHandler}
  //           />
  //         </div>
  //         <div>
  //           <label>
  //             <FMessage id="payments.purses.card.last-name" />
  //           </label>
  //           <Input
  //             className="text-uppercase"
  //             placeholder="IVANOV"
  //             value={lastName}
  //             onChange={(e) => this.handleNameChange(e, 'last')}
  //             disabled={disabled}
  //             onBlur={this.handleBlur}
  //             onFocus={this.inputFocusHandler}
  //           />
  //         </div>
  //         <button
  //           className="btn btn-primary btn-sm bank-card-button"
  //           onClick={() => {
  //             this.handleSubmit('error', null);
  //             this.setState({ firstName: '', lastName: '' });
  //           }}
  //           disabled={!number || !firstName || !lastName}
  //           theme={theme}
  //         >
  //           <FMessage id="payment-data.wallets.code-gen.get" />
  //         </button>
  //       </div>
  //       <FormText color="muted">{this.renderMutedText({ newField: true })}</FormText>
  //       {error && <small className="form-text">{error}</small>}
  //     </FormGroup>
  //   );
  // };
  renderNewPurseField = ({ index }) => {
    const { type, placeholder, isSlave, theme, wallets } = this.props;
    const { number, error, isFocused } = this.state;
    const disabled = isSlave;
    // форматирование для банковских карт
    const value =
      type === 3 || type === 30 || type === 37 ? this.formatBankCardNumber(number) : number;
    const onChange =
      type === 3 || type === 30 || type === 37
        ? this.handleBankCardNumberChange
        : this.handleChange;
    // Банковская карта RU
    // if (type === 3) {
    //   return this.renderNewBankCardRU(index);
    // }

    return (
      <Fragment>
        <FormGroup
          className={cn('payment-purses-list', 'form-group-upper-label', { 'has-error': error })}
        >
          {this.renderWalletsLabel({ index })}
          {/* <FormText color="muted">{this.renderMutedText({ newField: true })}</FormText> */}

          <InputGroup>
            <Input
              innerRef={this.newPurseRef}
              id={`purse-${type}`}
              // className="text-uppercase"
              // placeholder={placeholder}
              value={value}
              onChange={onChange}
              disabled={disabled}
              onBlur={this.handleBlur}
              onFocus={this.inputFocusHandler}
              autoFocus={isFocused}
            />
            <InputGroupAddon addonType="append">
              <GetCodeBtn
                handleSubmit={() => this.handleSubmit('error', null)}
                disabled={!number}
                addLabel={type === 29 || type === 36}
              />
            </InputGroupAddon>
          </InputGroup>

          {type === 11 && (
            <FormText color="muted">
              <RegesterWithEPayments />
            </FormText>
          )}
          {error && <small className="form-text">{error}</small>}
        </FormGroup>
      </Fragment>
    );
  };

  renderNewPurseFieldTheme4 = ({ index }) => {
    const { type, placeholder, isSlave, theme, wallets } = this.props;
    const { number, error, isFocused } = this.state;
    const disabled = isSlave;
    // форматирование для банковских карт
    const value =
      type === 3 || type === 30 || type === 37 ? this.formatBankCardNumber(number) : number;
    const onChange =
      type === 3 || type === 30 || type === 37
        ? this.handleBankCardNumberChange
        : this.handleChange;
    // Банковская карта RU
    // if (type === 3) {
    //   return (
    //     <Col xs="5" lg="8" md="6" className="no-padding">
    //       {this.renderNewBankCardRU(index)}
    //     </Col>
    //   );
    // }

    return (
      <Fragment>
        <FormGroup
          row
          className={
            error
              ? `form-group-upper-label has-error mx-0 new-purse-input ${
                  wallets.length === 0 ? 'no-purses' : ''
                }`
              : `form-group-upper-label mx-0 new-purse-input ${
                  wallets.length === 0 ? 'no-purses' : ''
                }`
          }
        >
          <Col xs="5" lg="8" md="6" className="no-padding">
            {wallets.length === 0 && this.renderWalletsLabel({ index, theme })}
            <FormText color="muted">{this.renderMutedText({ newField: true })}</FormText>
            <Input
              innerRef={this.newPurseRef}
              id={`purse-${type}`}
              // className="text-uppercase"
              // placeholder={placeholder}
              value={value}
              onChange={onChange}
              disabled={disabled}
              onBlur={this.handleBlur}
              onFocus={this.inputFocusHandler}
              autoFocus={isFocused}
            />
            {type === 11 && (
              <FormText color="muted">
                <RegesterWithEPayments />
              </FormText>
            )}

            {error && <small className="form-text">{error}</small>}
          </Col>
          <GetCodeBtn
            handleSubmit={() => this.handleSubmit('error', null)}
            disabled={!number}
            addLabel={type === 29 || type === 36}
          />
        </FormGroup>
      </Fragment>
    );
  };

  renderMutedText = ({ index, keyForSMSInput, newField, id }) => {
    const {
      wallets,
      multiple,
      isSlave,
      maxWalletsForMultiple,
      type,
      profile,
      handleChangeNewWalletSMSInputTargetId,
    } = this.props;
    let muted = null;
    let newMuted = null;

    if (
      multiple &&
      wallets.length === maxWalletsForMultiple &&
      index === wallets.length - 1 &&
      type === 5
    ) {
      muted = (
        <span className="wallets-count-limit">
          <FMessage id={`payment-data.wallets.max-limit${type === 3 ? '.bank' : ''}.muted`} />
        </span>
      );
    } else if (
      multiple &&
      wallets.length === maxWalletsForMultiple &&
      index === wallets.length - 1
    ) {
      muted = (
        <Fragment>
          {/* <CodeGenTextLinkComponent
            type={type}
            onClick={() => handleChangeNewWalletSMSInputTargetId(keyForSMSInput, id)}
          /> */}
          <span className="wallets-count-limit">
            <FMessage id={`payment-data.wallets.max-limit${type === 3 ? '.bank' : ''}.muted`} />
          </span>
        </Fragment>
      );
    } else if (!profile.phone || (profile.phone && !profile.phone_approved)) {
      muted = <AfterApprovePhoneTextComponent />;
    } else if (multiple && wallets.length !== maxWalletsForMultiple) {
      muted = null;
    } else if (wallets.length - 1 !== index) {
      muted = null;
    } else if (!isSlave) {
      muted = <SupportTextComponent />;
    } else if (isSlave) {
      muted = <BlockChangesText />;
    }
    // для новых инпутов
    // if (type === 15) {
    //   newMuted = <WmzEmptyText />;
    // }
    return (
      <div>
        <div>{newMuted}</div>
        <p>{muted}</p>
      </div>
    );
  };

  focusNewInput = (node) => {
    const newInput = node.querySelector('input');
    newInput.focus();
  };

  inputFocusHandler = () => {
    const { showAlert, intl } = this.props;
    showAlert({
      alertType: 'warning',
      message: iFMessage({
        intl,
        id: `payment-data.wallets.disclaimer.text`,
      }),
      dismissable: true,
    });
  };

  inputBlurHandler = () => {
    const { closeAlert } = this.props;
    closeAlert();
  };

  render() {
    const {
      type,
      theme,
      wallets,
      multiple,
      isSlave,
      maxWalletsForMultiple,
      title,
      placeholder,
      newWalletSMSInputTargetId,
    } = this.props;
    const {
      newWalletSMSInput,
      newWalletSMSInputError,
      editWalletNumber,
      editWalletError,
      isEditWalletModalOpen,
    } = this.state;

    let shouldHideNewWallet = wallets.length >= maxWalletsForMultiple;

    return (
      <Fragment>
        {wallets.length > 0 ? (
          <PaymentPursesListItemView
            data={{ ...this.state, ...this.props, shouldHideNewWallet }}
            getFormClassName={this.getFormClassName}
            inputFocusHandler={this.inputFocusHandler}
            inputBlurHandler={this.inputBlurHandler}
            handleDelete={this.handleDelete}
            toggleWalletMenu={this.toggleWalletMenu}
            handleEditWallet={this.handleEditWallet}
            renderMutedText={this.renderMutedText}
            focusNewInput={this.focusNewInput}
            handleNewWalletChange={this.handleNewWalletChange}
            handleSubmit={this.handleSubmit}
            renderNewPurseField={this.renderNewPurseField}
            renderNewPurseFieldTheme4={this.renderNewPurseFieldTheme4}
            renderWalletsLabel={this.renderWalletsLabel}
          />
        ) : (
      // ) : theme === 4 ? (
      //   this.renderNewPurseFieldTheme4({ index: 0 })
      // <Fragment>
      //   {wallets.map(({ id, number }, index) => (
      //     <div key={id}>
      //       <FormGroup className={this.getFormClassName(index)}>
      //         {theme !== 3 && this.renderWalletsLabel({ id, index })}

      //         <InputGroup>
      //           <Input
      //             id={`purse-${type}-${id}`}
      //             className="text-uppercase"
      //             value={number}
      //             onChange={() => false}
      //             readOnly={number && number.length && !isSlave}
      //             disabled={isSlave}
      //             onFocus={this.inputFocusHandler}
      //             onBlur={this.inputBlurHandler}
      //           />

      //           {multiple && (
      //             <InputGroupAddon addonType="append">
      //               <DeleteBtn
      //                 isSlave={isSlave}
      //                 handleDelete={this.handleDelete}
      //                 id={id}
      //                 type={type}
      //               />
      //             </InputGroupAddon>
      //           )}
      //         </InputGroup>
      //         <FormText color="muted">
      //           {this.renderMutedText({
      //             index,
      //             keyForSMSInput: `purse-${type}-${id}_${index}`,
      //             id,
      //             type,
      //           })}
      //         </FormText>
      //       </FormGroup>
      //       <CSSTransition
      //         in={newWalletSMSInputTargetId === `purse-${type}-${id}_${index}`}
      //         timeout={0}
      //         classNames="new-wallet"
      //         onEnter={this.focusNewInput}
      //       >
      //         <GetNewCodeInput
      //           title={title}
      //           type={type}
      //           value={newWalletSMSInput}
      //           handleChange={this.handleNewWalletChange}
      //           handleSubmit={() => this.handleSubmit('newWalletSMSInputError', id)}
      //           placeholder={placeholder}
      //           error={newWalletSMSInputError}
      //           id={`purse-${type}-${id}-sms`}
      //           className="new-wallet"
      //           onFocus={this.inputFocusHandler}
      //           onBlur={this.inputBlurHandler}
      //         />
      //       </CSSTransition>
      //     </div>
      //   ))}

      //   {multiple &&
      //     !shouldHideNewWallet &&
      //     this.renderNewPurseField({ index: wallets.length, noWallets: !wallets.length })}
      // </Fragment>
          this.renderNewPurseField({ index: 0 })
        )}

        <Modal
          modalClassName="modal-edit-wallet"
          isOpen={isEditWalletModalOpen}
          toggle={this.closeEditWalletModal}
          centered
        >
          <ModalHeader>
            <FMessage id="payment-data.wallets.edit-modal.title" />
          </ModalHeader>
          <ModalBody>
            <FormGroup className={cn({ 'has-error': editWalletError })}>
              <Label for={`edit-purse-${type}`}>e-mail</Label>
              <Input
                id={`edit-purse-${type}`}
                type="email"
                value={editWalletNumber}
                onChange={this.handleEditWalletNumberChange}
                autoFocus
              />
              {editWalletError && <small className="form-text">{editWalletError}</small>}
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              className="edit-wallet-cancel"
              color="light"
              onClick={this.closeEditWalletModal}
            >
              <FMessage id="main.cancel" />
            </Button>
            <Button
              type="button"
              className="edit-wallet-submit"
              color="primary"
              disabled={!editWalletNumber}
              onClick={this.handleEditWalletSubmit}
            >
              <FMessage id="main.change" />
            </Button>
          </ModalFooter>
        </Modal>
      </Fragment>
    );
  }
}

export default injectIntl(PaymentPursesListItem);
